import { useMemo } from "react";
import { useQueries } from "../services/queries/use-queries"

export const useCategoryManagementUseMemo = () => {
    const {
        role,
        isLoadingRole,
        isErrorRole,
        errorMessageRole,

        department,
        isLoadingDepartment,
        isErrorDepartment,
        errorMessageDepartment,

        location,
        isLoadingLocation,
        isErrorLocation,
        errorMessageLocation,
    } = useQueries()
    const isLoading = isLoadingRole || isLoadingDepartment || isLoadingLocation
    const isError = isErrorRole || isErrorDepartment || isErrorLocation
    const errorMessage = errorMessageRole || errorMessageDepartment || errorMessageLocation

    const categoryData = useMemo(
        () => ({
            roles: role?.map((cat) => ({
                id: cat.id,
                name: cat.name,
                status: cat.is_active,
                code: cat.code,
                type: "roles" as const,
            })) ?? [],
            departments: department?.map((cat) => ({
                id: cat.id,
                name: cat.name,
                status: cat.is_active,
                code: cat.code,
                type: "departments" as const,
            })) ?? [],
            locations: location?.map((cat) => ({
                id: cat.id,
                name: cat.name,
                status: cat.is_active,
                code: cat.code,
                type: "locations" as const,
            })) ?? [],
        }),
        [role, department, location]
    );


    return {
        categoryData,
        isLoading,
        isError,
        errorMessage
    }
}